<template>
     <div class="article_watch">
        <el-form label-position="right" label-width="90px" ref="ruleForm" :model="row" :rules='rules' :disabled="row.status === '查看'">
            <el-form-item label="文章序号:"  prop="文章序号">
                <el-input v-model="row.文章序号"></el-input>
            </el-form-item>
            <!-- <el-form-item label="活动区域">
                <el-input v-model="formLabelAlign.region"></el-input>
            </el-form-item> -->
            <el-form-item label="文章名称"  prop="文章名称">
                <el-input v-model="row.文章名称"></el-input>
            </el-form-item>
            <!-- deprecated
            <el-form-item label="作者"  prop="作者">
                <el-input v-model="row.作者"></el-input>
            </el-form-item>
            -->
             <el-form-item label="核心词"  prop="核心词">
                <el-input v-model="row.核心词" ></el-input>
            </el-form-item>
            <!-- deprecated
             <el-form-item label="页码"  prop="页码">
                <el-input v-model="row.页码"></el-input>
            </el-form-item>
            -->
              <el-form-item
                    v-for="(domain, index) in row.句子"
                    :label="'句子'+index"
                    :key="domain.key"
                    :prop="'句子['+index+'].value'"
                    :rules="[
                {  required: true,  message: '请输入', trigger: 'blur' }
            ]"
                >
                <div class="domain">
                     <el-input v-model="domain.value"  maxlength="30"></el-input>
                    <el-button v-if="row.句子.length <= 1?false:true" @click.prevent="removeDomain(domain)" type="info" icon="el-icon-delete" circle></el-button>
                     <el-button @click="addDomain" v-if="row.句子.length-1 === index?true:false" type="info" icon="el-icon-plus"  circle=""></el-button>

                </div>
                   
                </el-form-item>
             
             <!-- <el-form-item label="句子">
                <el-input v-model="row.句子"></el-input>
            </el-form-item> -->
               <el-form-item label="音频文件">
                    <el-upload
                        class="upload-demo"
                        ref="customUpload"
                        :action="target+'file/upload'"
                        :data="tokenchange"
                        :before-upload="handleBeforeUpload"
                        :on-success="handsuccess"
                        :on-remove="imgremove"
                        :on-exceed="handleExceed"
                        :on-change="upl"
                        multiple
                        accept='.mp3,.m4a,*.cda,.wav,.aac,.wma,.ogg,.flac,.ape,.wav,.amr,.3gpp,.he-aac'
                        :limit="1"
                        :auto-upload="false"
                        >
                    <el-button size="small" type="primary" >点击上传</el-button>
                    <p>{{row.文件}}</p>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传mp3文件，且不超过500kb</div> -->
            </el-upload>
            </el-form-item>
            <el-form-item >
             
              
            </el-form-item>
           
        </el-form>
           <div class="starUp_button">
                 <el-button @click="goback">取消</el-button>
                <el-button  type="primary" :disabled="row.status === '查看'" @click="save('ruleForm')">保存</el-button>
                </div>
       </div>
</template>
<script>
import testServer from '@/api/management.js'
export default {
    data () {
        return {
            row:{},
            status:true,
            updataStatus:false,
            target:'',
             article:{
                star:''
                },
            rules: {
            文章序号: [
            
                {  required: true,  message: '请输入', trigger: 'blur' },
              
            ],
            文章名称:[
                {  required: true,  message: '请输入', trigger: 'blur' }
            ],
            作者: [
                { required: true,  message: '请输入', trigger: 'blur' }
            ],
            核心词: [
            
                {  required: false,  message: '请输入', trigger: 'blur' },
              
            ],
            页码:[
                {  required: true,  message: '请输入', trigger: 'blur' }
            ],
          
            
            },
        }
    },
    mounted () {
       
    let proEnv = require('../../../config/pro.env');  // 生产环境
const env = process.env.NODE_ENV;
let target = '';
if(env==='production'){  // 生产环境
  target = proEnv.hosturl+'/';
}else{  // 本地环境
  target = '/'
}
this.target =target
           this.article = JSON.parse(sessionStorage.getItem('articlStar') ) 
            this.row = this.$route.query.row
             if (this.row.文件) {
            this.updataStatus = true
        }
            console.log('/文章查看修改',this.article)
    },
     computed:{
    tokenchange(){
      return {
        token: JSON.parse(sessionStorage.getItem('token')).token
        }
    },
    },
    methods: {
    goback(){
        this.$router.go(-1)
    },
    handsuccess(response){
        console.log('dad')
           this.fileSuseese  = response.status
     if(response.status === 0){
                    let  sentenceJson  = []
                for (let index = 0; index < this.row.句子.length; index++) {
                    sentenceJson.push(this.row.句子[index].value)
                }
                console.log(sentenceJson)
                    let change = {
                        id:this.row.id,
                        serialNumber:this.row.文章序号,
                        name:this.row.文章名称,
                        //author:this.row.作者,
                        coreWords:this.row.核心词,
                        //pageNumber:this.row.页码,
                        sentenceJson:JSON.stringify(sentenceJson),
                        star:this.article,
                        audio: response.data
                    }
                testServer.article.save(change).then(res =>{
                    if( res.data.status === 0 ){
                        this.$router.push({
                                                name:'文章查看',
                                                query:{
                                                    star: this.article
                                                }
                                            }) 
                        
                    }
                })
     }
    },
    upl(file,filelist){
        console.log('ada',file)
        this.row.文件 = undefined
        this.updataStatus = true
        console.log(filelist)
    },
    handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件 `);
    },
    removeDomain(item) {
        var index = this.row.句子.indexOf(item)
        if (index !== -1) {
          this.row.句子.splice(index, 1)
        }
      },
    addDomain() {
       
        this.row.句子.push({
            value: '',
          key: Date.now()
        })
      },
    save(formName){
        console.log()
        this.$refs[formName].validate((valid) => {
          if (valid) {
              if (   this.updataStatus === true) {
                if(this.row.文件 === undefined){
                 console.log('wswswsw')
                this.$refs.customUpload.submit();
                } else {
                    let  sentenceJson  = []
                    for (let index = 0; index < this.row.句子.length; index++) {
                        sentenceJson.push(this.row.句子[index].value)
                    }
                let change = {
                            id:this.row.id,
                            serialNumber:this.row.文章序号,
                            name:this.row.文章名称,
                            //author:this.row.作者,
                            coreWords:this.row.核心词,
                            //pageNumber:this.row.页码,
                            sentenceJson:JSON.stringify(sentenceJson),
                            star:this.article,
                            audio: this.row.文件
                        }
                    testServer.article.save(change).then(res =>{
                        if( res.data.status === 0 ){
                            this.$router.push({
                                                    name:'文章查看',
                                                    query:{
                                                        star:this.article
                                                    }
                                                }) 
                            
                        }
                    })           
                        
            }   
              } else {
                     const h = this.$createElement;
                            this.$notify({
                                   
                                    message: h('i', { style: 'color: 000'}, '请上传文件')
                                    });
              }
                
             
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      
    }
    }
}
</script>
<style lang="scss" scoped>
.article_watch{
    margin: 0 auto;
    width: 600px;
     .domain{
        display: flex;

    }
}
.starUp_button{
    margin-left: 80px;
   display: flex;
   justify-content: center;

}
</style>
